import { toExtendedAttributeCalendarDate } from 'app/library/extended-attributes/utils/extended-attribute-date.util';
import { ExtendedAttributeType } from '../enums/extended-attribute-type.enum';
import { IEditExtendedAttributeValue } from '../interfaces/edit-extended-attribute-value.interface';

export class EditExtendedAttributeValueCommand {
    user: {
        id: number;
    };
    extended_attribute: {
        id: number;
    };
    value_number: number;
    value_text: string;
    value_date: Date;
    value_address: {
        street_name: string;
        street_number: string;
        zip_code: string;
        city: string;
        country: string;
    };
    hidden_from_others: boolean;

    constructor(payload: IEditExtendedAttributeValue) {
        this.user = {
            id: parseInt(payload.userId),
        };
        this.extended_attribute = {
            id: parseInt(payload.extendedAttribute.id),
        };
        if (payload.extendedAttribute.type === ExtendedAttributeType.Number) {
            this.value_number = payload.value as number;
        }
        if (payload.extendedAttribute.type === ExtendedAttributeType.Text) {
            this.value_text = payload.value as string;
        }
        if (payload.extendedAttribute.type === ExtendedAttributeType.Date) {
            this.value_date = toExtendedAttributeCalendarDate(payload.value);
        }
        if (payload.valueAddress) {
            this.value_address = {
                street_name: payload.valueAddress?.streetName,
                street_number: payload.valueAddress.streetNumber?.toString(),
                zip_code: payload.valueAddress.zipCode?.toString(),
                city: payload.valueAddress?.city,
                country: payload.valueAddress?.country,
            };
        }
        if (payload.hiddenFromOthers) {
            this.hidden_from_others = payload.hiddenFromOthers === 'true' ? true : false;
        }
    }
}
